/* Oakline — storefront filters and sorting without page reloads */
(() => {
  const theme = window.theme || {};

  if (theme.DrawerElement && !customElements.get('facet-drawer')) {
    customElements.define('facet-drawer', class extends theme.DrawerElement {});
  }

  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.sectionId = this.dataset.section;
      this.formId = this.dataset.formId;
      this.cache = new Map();
      this.debouncedSubmit = theme.debounce(() => this.submit(), 600);

      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-sort-mobile]')) {
          const desktop = document.querySelector(`[form="${this.formId}"][data-sort]`);
          if (desktop) desktop.value = event.target.value;
        }
        if (event.target.type === 'number') return;
        this.submit();
      });
      this.form.addEventListener('input', (event) => {
        if (event.target.type === 'number') this.debouncedSubmit();
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });

      this.onExternalChange = (event) => {
        if (event.target.matches && event.target.matches(`[form="${this.formId}"]`)) this.submit();
      };
      document.addEventListener('change', this.onExternalChange);

      this.onClick = (event) => {
        const remove = event.target.closest('[data-facet-remove], [data-facet-clear]');
        if (remove && remove.closest(`[data-section="${this.sectionId}"]`)) {
          event.preventDefault();
          const url = new URL(remove.href, window.location.origin);
          this.render(url.searchParams.toString());
        }
        const more = event.target.closest('[data-facet-more]');
        if (more && this.contains(more)) {
          const list = more.parentElement.querySelector('[data-facet-list]');
          if (list) list.classList.add('is-expanded');
          more.hidden = true;
        }
      };
      document.addEventListener('click', this.onClick);

      this.onPopState = (event) => {
        const query = event.state && typeof event.state.facets === 'string' ? event.state.facets : window.location.search.slice(1);
        this.render(query, false);
      };
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onExternalChange);
      document.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
    }

    submit() {
      const params = new URLSearchParams(new FormData(this.form));
      const clean = new URLSearchParams();
      for (const [key, value] of params.entries()) {
        if (value !== '') clean.append(key, value);
      }
      this.render(clean.toString());
    }

    async render(query, updateHistory = true) {
      const section = document.querySelector(`.collection[data-section="${this.sectionId}"]`) || document;
      const grid = section.querySelector('[data-product-grid]');
      if (grid) grid.classList.add('is-loading');
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}${query ? `&${query}` : ''}`;
      try {
        let html = this.cache.get(url);
        if (!html) {
          html = await fetch(url).then((response) => response.text());
          this.cache.set(url, html);
        }
        this.swap(theme.parseHTML(html));
        if (updateHistory) {
          window.history.pushState({ facets: query }, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
        }
      } catch (error) {
        theme.toast && theme.toast(theme.strings.cartError, 'error');
      } finally {
        const freshGrid = section.querySelector('[data-product-grid]');
        if (freshGrid) freshGrid.classList.remove('is-loading');
      }
    }

    swap(doc) {
      const id = this.sectionId;
      const replace = (selector) => {
        const fresh = doc.querySelector(selector);
        const current = document.querySelector(selector);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      };
      replace(`#ProductGridContainer-${CSS.escape(id)}`);
      replace(`#ActiveFilters-${CSS.escape(id)}`);
      replace(`#ProductCount-${CSS.escape(id)}`);

      // Update each filter group while keeping open/closed state and typed prices
      this.querySelectorAll('details[data-facet]').forEach((details) => {
        const key = details.dataset.facet;
        const fresh = [...doc.querySelectorAll('details[data-facet]')].find((el) => el.dataset.facet === key);
        if (!fresh) return;
        const list = details.querySelector('[data-facet-list]');
        const freshList = fresh.querySelector('[data-facet-list]');
        if (list && freshList) {
          const expanded = list.classList.contains('is-expanded');
          list.innerHTML = freshList.innerHTML;
          list.classList.toggle('is-expanded', expanded);
        }
        const summary = details.querySelector('summary');
        const freshSummary = fresh.querySelector('summary');
        if (summary && freshSummary) summary.innerHTML = freshSummary.innerHTML;
      });

      const grid = document.querySelector(`#ProductGridContainer-${CSS.escape(id)}`);
      if (grid && theme.initReveal) theme.initReveal(grid);
      grid?.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
    }
  }

  if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);
})();
